import { render, staticRenderFns } from "./bgcDataNow.vue?vue&type=template&id=3961aaf1&scoped=true"
import script from "./bgcDataNow.vue?vue&type=script&lang=js"
export * from "./bgcDataNow.vue?vue&type=script&lang=js"
import style0 from "./bgcDataNow.vue?vue&type=style&index=0&id=3961aaf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3961aaf1",
  null
  
)

export default component.exports